import styled from '../../utils/styled';
import { Button, ButtonProps } from '../Button';

export const SubAction = styled(Button).attrs(() => ({ variant: 'subtle', kind: 'link', size: 'sm' }))<ButtonProps>``;

SubAction.displayName = 'FeatureCard.SubAction';
